import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

// 0 means "All organizations". Keeps the legacy showAllContract flag in step
// so a stale value from a previous session can't contradict the filter.
const persistChecklistOrgFilter = (organizationId) => {
  const value = Number(organizationId) || 0;
  localStorage.setItem("checklistOrgFilter", String(value));
  localStorage.setItem("showAllContract", value === 0 ? "true" : "false");
  return value;
};

export default {
  state: {
    checklistDropdowns: [],
    membersDropdownForContract: [],
    checklistByBroker: [],
    contractByUser: [],
    contractByMemberUser: [],
    contractById: [],
    publicLinkData: [],
    contractViaDocumentDraft: null,
    showChecklistIndicator: false,
    // Always start on "All" (0); user can still filter while on /checklist
    checklistOrgFilter: persistChecklistOrgFilter(0),
  },
  getters: {
    getChecklistDropdowns: (state) => state.checklistDropdowns,
    getMembersDropdownForContract: (state) => state.membersDropdownForContract,
    getChecklistByBroker: (state) => state.checklistByBroker,
    getContractByUser: (state) => state.contractByUser,
    getContractByMemberUser: (state) => state.contractByMemberUser,
    getContractById: (state) => state.contractById,
    sharePublicLinkData: (state) => state.publicLinkData,
    getContractViaDocumentDraft: (state) => state.contractViaDocumentDraft,
    getShowChecklistIndicator: (state) => state.showChecklistIndicator,
    getChecklistOrgFilter: (state) => state.checklistOrgFilter,
  },
  actions: {
    async createChecklist({ commit }, payload) {
      const url = "ContractSchedules/SaveContractSchedule";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async getChecklistDropdowns({ commit }, id) {
      let url = `ContractSchedules/AllDropDownForContractSchedule?organizationId=${id}&isAll=true`;
      const response = await makeApiCall(url, "POST");
      if (!response.error) {
        commit("setChecklistDropdowns", response.data.data);
      }
    },
    async getMembersDropdownForContract({ commit }, id) {
      let url = `ContractSchedules/MembersDropDownForContractSchedule?brokerId=${id}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setMembersDropdownForContract", response.data.data.members);
      }
    },
    async saveMemberForContractSchedule({ commit }, payload) {
      let url = `Member/SaveMemberforContractSchedule`;
      const response = await makeApiCallWithImages(url, "POST", payload);
      return response;
    },
    async memberGeneratePassKey({ commit }, payload) {
      const url = "Member/GeneratePassKey";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async getChecklistByBroker({ commit }, payload) {
      let url = `ContractSchedules/GetContractSchedule`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setChecklistByBroker", response.data.data);
      }
      return response;
    },
    async getContractByUser({ commit }, payload) {
      let url = `ContractSchedules/GetContractScheduleByUser`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setContractByUser", response.data.data);
      }
      return response;
    },
    async getContractByMemberUser({ commit }, payload) {
      let url = `ContractSchedules/GetContractSchedule`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setContractByMemberUser", response.data.data);
      }
      return response;
    },
    async getContractById({ commit }, payload) {
      let url = `ContractSchedules/GetContractScheduleById`;
      const response = await makeApiCall(url, "POST", payload);
      if (!response.error) {
        commit("setContractById", response.data.data?.baseContractScheduleQuery);
      }
      return response;
    },
    async getContractsByUserOrganizations({ commit }, payload) {
      let url = `ContractSchedules/GetContractsByUserOrganizations`;
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async taskDragAndDrop({ commit }, payload) {
      const url = "ContractSchedules/ContractScheduleTaskDragDrop";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async markTaskAsCompleted({ commit }, payload) {
      let url = `ContractSchedules/ContractScheduleTaskStatusUpdate`;
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async deleteContractScheduled({ commit }, id) {
      let url = `ContractSchedules/DeleteContract?contractScheduleId=${id}`;
      const response = await makeApiCall(url, "DELETE");
      return response;
    },
    async saveAsTemplate({ commit }, payload) {
      let url = "ContractSchedules/SaveAsTemplate";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async saveChecklistStatus({ commit }, payload) {
      const url = `ContractSchedules/ChecklistStatus?ContractId=${payload.ContractId}&CheckListStatus=${payload.CheckListStatus}`;
      const response = await makeApiCall(url, "POST");
      return response;
    },
    async sendEmail({ commit }, payload) {
      const url = "ContractSchedules/ShareCheckListEmail";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async updateEmailMessage({ commit }, payload) {
      const url = "ContractSchedules/UpdateEmailMessages";
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
    async sharePublicLinkData({ commit }, payload) {
      const url = `ContractSchedules/PublicLinkShare?token=${payload.token}`;
      const response = await makeApiCall(url, "POST");
      if (!response.error) {
        commit("setSharePublicLinkData", response.data.data);
        return response;
      }
      return response;
    },
    async getContractScheduleDates({ commit }, payload) {
      const url = `ContractSchedules/GetContractScheduleDates?UserId=${payload.UserId}&OrganizationId=${payload.OrganizationId}`;
      const response = await makeApiCall(url, "GET");
      return response;
    },
    async saveContractScheduleMedia({ commit }, formData) {
      const url = "ContractSchedules/SaveContractScheduleMedia";
      const response = await makeApiCallWithImages(url, "POST", formData);
      return response;
    },
    async getChatGptTemplateTask({ commit }, payload) {
      const formData = new FormData();
      formData.append("File", payload.file, payload.file.name);
      formData.append("TemplateId", String(payload.templateId));
      formData.append("TemplateName", payload.templateName || "");
      formData.append("TasksJson", payload.tasksJson || "[]");
      const url = "ContractSchedules/getChatGptTemplateTask";
      const response = await makeApiCallWithImages(url, "POST", formData);
      return response;
    },
    async deleteContractScheduleDocument({ commit }, documentId) {
      const url = `ContractSchedules/DeleteContractScheduleDocument?contractDocumentId=${documentId}`;
      const response = await makeApiCall(url, "DELETE");
      return response;
    },
    setChecklistOrgFilter({ commit }, organizationId) {
      commit("setChecklistOrgFilter", organizationId);
    },
    async deleteContractScheduleMedia({ commit }, mediaId) {
      const url = `ContractSchedules/deleteContractScheduleMedia?id=${mediaId}`;
      const response = await makeApiCall(url, "DELETE");
      return response;
    },
  },
  mutations: {
    setChecklistDropdowns: (state, payload) =>
      (state.checklistDropdowns = payload),
    setMembersDropdownForContract: (state, payload) =>
      (state.membersDropdownForContract = payload),
    setChecklistByBroker: (state, payload) =>
      (state.checklistByBroker = payload),
    setContractByUser: (state, payload) => (state.contractByUser = payload),
    setContractByMemberUser: (state, payload) => (state.contractByMemberUser = payload),
    setContractById: (state, payload) => (state.contractById = payload),
    setSharePublicLinkData: (state, payload) =>
      (state.publicLinkData = payload),
    setContractViaDocumentDraft: (state, payload) => {
      state.contractViaDocumentDraft = payload;
    },
    clearContractViaDocumentDraft: (state) => {
      state.contractViaDocumentDraft = null;
    },
    setShowChecklistIndicator: (state, value) => {
      state.showChecklistIndicator = !!value;
    },
    setChecklistOrgFilter: (state, payload) => {
      state.checklistOrgFilter = persistChecklistOrgFilter(payload);
    },
  },
};
